import React, {useMemo} from 'react';

import PolymerMapWrapper from 'molbio/bulk-assembly/polymer-map-modals/PolymerMapWrapper';
import {TabView, SimplifiedOptionsView} from 'molbio/maps/linear/ProteinMapView';
import Protein from 'molbio/proteins/Protein';
import ProteinMapTabState from 'molbio/tabstates/ProteinMapTabState';

export default function ProteinMapContainer({
  protein,
  className,
}: {
  protein: Protein;
  className?: string;
}): JSX.Element {
  const proteinMapTabState = useMemo(() => new ProteinMapTabState({protein}), [protein]);
  return (
    <PolymerMapWrapper
      className={className}
      TabOptionsViewCls={SimplifiedOptionsView}
      TabContentViewCls={TabView}
      tabState={proteinMapTabState}
    />
  );
}
